import { useMemo } from "react";
import { useFinancialAccounts } from "@hooks/useFinancialAccounts";
import { FinancialAccountSourceType } from "@common/types/financialAccount";
import {
    UNIQUE_INTEGRATIONS,
    IntegrationFilterOption,
} from "@components/history/components/integrationActors";

export function useConnectedIntegrations(): IntegrationFilterOption[] {
    const allAccounts = useFinancialAccounts();

    return useMemo(() => {
        const connectedSourceTypes = new Set(
            allAccounts
                .map((a) => a.sourceType)
                .filter(
                    (t): t is FinancialAccountSourceType =>
                        !!t &&
                        t !== FinancialAccountSourceType.MANUAL &&
                        t !== FinancialAccountSourceType.FILE_IMPORT,
                ),
        );

        return UNIQUE_INTEGRATIONS.filter((integration) =>
            connectedSourceTypes.has(integration.accountSourceType),
        );
    }, [allAccounts]);
}

export function hasAllSourceTypes(
    selected: string[] | undefined,
    sourceTypes: string[],
): boolean {
    if (!selected) {
        return false;
    }
    return sourceTypes.every((st) => selected.includes(st));
}
